import embla from 'embla-carousel';

class ProductsSlider {
  constructor() {
    const sections = document.querySelectorAll('.products-slider');

    sections.forEach(section => {
      const root = section.querySelector('.products-slider__wrapper');
      const wrapper = section.querySelector('.products-slider__items');
      const items = section.querySelectorAll('.products-slider-item');

      const options = {
        dragFree: true,
        watchDrag: items.length > 2 ? true : false,
      };

      embla(root, options);

      const changeAnimation = () => {
        let width = 0;
        let duration = 0;

        items.forEach(item => {
          width = width + item.getBoundingClientRect().width;
          duration = duration + 4;
        });

        width = width / 2;
        duration = duration / 2;

        wrapper.style.setProperty('--width', -width + 'px');
        wrapper.style.setProperty('--duration', duration + 's');
      }

      document.addEventListener('DOMContentLoaded', () => changeAnimation());
      window.addEventListener('resize', () => changeAnimation());
    });
  }
}

export default ProductsSlider;
